module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmEU9fBBc-.40bcb2b8.woff";